/**
 * Version of the consent text the trader reads on E4 (specs/S6-trading-account/spec.md R14, R15):
 * the two sentences `onboarding.tradingAccount.can` and `.never` plus the checkbox label, in FR
 * and EN. It is a **draft**: it does not mention the shared reader (Q17) nor a third party that
 * would hold the credentials (Q12). The API refuses any `-draft` version in production, so the
 * draft can never be consented to there. A test pins this value on purpose: it changes when Julien
 * gives the text (Q17) and the versions get a publisher (Q72).
 */
// TODO(Q17): replace the draft with the definitive text and its version once Julien answers.
export const CONSENT_TEXT_VERSION = 'consent.v0-draft';
